module.exports = __webpack_public_path__ + "static/media/woman.edd0f2c8.svg";